/**
 * Creates a new api plugin instance with options
 * @param {Object} options
 * @param {String} options.useragent The instance of either server/api or client/api
 * @returns {UserAgentPlugin}
 */
function UserAgentPlugin(options) {
  /**
   * @class UserAgentPlugin
   */
  return {
    name: 'UserAgentPlugin',
    plugContext: function(contextOptions) {
      var useragent = contextOptions.useragent;
      if(useragent) {
        useragent.isiOs = useragent.isiPad || useragent.isiPhone || useragent.isiPod;
        useragent.isBanquetForAndroid = useragent.source === 'Banquet Android';
        useragent.isMobile = useragent.isMobile && !useragent.isTablet;
      }

      return {
        plugActionContext: function(actionContext) {
          actionContext.getUserAgent = function() {
            return useragent;
          };
        },
        plugComponentContext: function(componentContext) {
          componentContext.getUserAgent = function() {
            return useragent;
          };
        },
        dehydrate: function dehydrate() {
          return {
            useragent: contextOptions.useragent
          };
        },
        rehydrate: function rehydrate(state) {
          useragent = state.useragent;
        }
      };
    }
  };
}

export default UserAgentPlugin;



// WEBPACK FOOTER //
// banquet/plugins/UserAgentPlugin.js